import React from 'react';
import { Modal, ModalFuncProps, ModalProps } from 'antd';
import { dataTestIdFromTitle } from 'vl-common/src/utils';

type ConfirmationModalProps = ModalProps;

export const ConfirmationModal = (props: ConfirmationModalProps) => (
  <Modal
    centered
    {...props}
    title={props.title && <div data-testid={dataTestIdFromTitle(props.title)}>{props.title}</div>}
  />
);

export const confirmationModal = ({ ...otherProps }: ModalFuncProps) =>
  Modal.confirm({
    centered: true,
    ...otherProps,
    ...(otherProps.title && {
      title: <div data-testid={dataTestIdFromTitle(otherProps.title)}>{otherProps.title}</div>
    })
  });
